import CONFIG from './config.js';
import { setGlobalStorage, getGlobalStorage } from './storage';
import { getParentWindow, getTopWindow, getLocation } from './window.js';
import { getMicroContext, getRunContext, getMicroHref } from './qiankunContext.js';

//将sessionStorage里的值,做加密处理
// 判断浏览器是否为IE
const isIE = (
    navigator.userAgent.indexOf("MSIE") != -1 || !!window.ActiveXObject || "ActiveXObject" in window
);
const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') == -1; //判断是否Safari浏览器

let storageName = 'sessionStorage';
if (isIE || isSafari) {
    storageName = 'localStorage';
}

//新增clearUrlParams workbench切换集团或者用户重新加载单据的时候调用，解决YBP-FI-BUG-6137
export function clearUrlParams(){ //清空url中的业务参数
    let session = getGlobalStorage(storageName, 'NCCAPPURL');
    if(session){
        session = JSON.parse(session);
        for(let pop in session){
            let urlItem = session[pop];
            let urlArray = urlItem.split('&');
            let ifrIndex = urlArray.findIndex( e => e.includes('ifr='));
            if(ifrIndex != -1){
                let ifrItem = urlArray[ifrIndex];
                let [ ifr, ifrValue ] = ifrItem.split('=');
                if(ifrValue){
                    ifrValue = decodeURIComponent(decodeURIComponent(ifrValue));
                    let urlKeyMatchs = ifrValue.match(/urlKey=([^&$]+)/);
                    let urlKey = '';
                    if(urlKeyMatchs && urlKeyMatchs[1]){
                        urlKey = urlKeyMatchs[1];
                    }
                    if (ifrValue.includes('#/')) { // 业务参数在hash之后
                        const val = ifrValue.split('#/');
                        if (val[1]) {
                            val[1] = val[1].split('?')[0]
                        }
                        ifrValue = val.join('#/');
                    } else {
                        const queryIndex = ifrValue.indexOf('?');
                        // 删除ifr中除urlKey以外的参数
                        if (queryIndex !== -1) {
                            ifrValue = ifrValue.substring(0, queryIndex);
                        }
                    }
                    if(urlKey){
                        ifrValue = ifrValue + '?urlKey=' + urlKey;
                    }
                    ifrValue = encodeURIComponent(encodeURIComponent(ifrValue));
                }
                urlArray[ifrIndex] = 'ifr=' + ifrValue;
                session[pop] = urlArray.join('&');
            }
        }
        session = JSON.stringify(session);
        setNCCUrlStorage(session);
    }
}

export function getAppUrl(urlKey, runContext) { 
    let pageid = '', pageKey = 'page', pageStore = '';
    if(urlKey){
        pageid = urlKey;
    }else{
        pageid = getUrlKey(); // 取自身的key
        if (!pageid) {
            let topHash = getTopWindow().location.hash;
            if (topHash.split('?') && topHash.split('?')[1]) {
                pageid = topHash.split('?')[1].split("=")[1];
            }
        }
        // let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
        //内部页签 获取上下文的key，再去sessionStorage中查找

        // if (isInsideTab) {
        //     let urlkey = getUrlKey();
        //     if (urlkey) {
        //         pageid = urlkey;
        //     }
        // }
    }

    //内部页签pageid需要在window里取
    // if (JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'))) {
    //     pageid = window.pageId ? window.pageId : pageid
    // }
    //修改参数存放store
    //let storeCipher = getGlobalStorage('localStorage', 'storeCipher') == '0' ? false : true;
    let session = getGlobalStorage(storageName, 'NCCAPPURL');
    // if (storeCipher) {
    //     session = session && decrypt(session, aeskey);
    // }
    session = session && JSON.parse(session);
    pageStore = session && session[pageid];
    if (
        pageKey === "page" &&
        pageStore
    ) {
        return {
            pageid: pageid,
            pageurl: pageStore,
        }
    } else {
        return {
            pageid: '',
            pageurl: '',
        }
    }
}

export function setAppUrl(key, newParamStr) {
    let runContext = getRunContext();
    console.log('setAppUrl========', runContext, key, newParamStr);
    //如是乾坤模式，同步修改当前window的history

    //let storeCipher = getGlobalStorage('localStorage', 'storeCipher') == '0' ? false : true;
    let session = getGlobalStorage(storageName, 'NCCAPPURL');
    // if (storeCipher && session) {
    //     session = decrypt(session, aeskey);
    // }
    session = session && JSON.parse(session);

    if (session) {
        session[key] = newParamStr;
    } else {
        session = { [key]: newParamStr }
    }

    session = JSON.stringify(session);

    // if (storeCipher) {
    //     session = encrypt(session, aeskey); 
    // }
    setNCCUrlStorage(session);

}

export function setNCCUrlStorage(session) {
    if (isIE) {
        try {
            setGlobalStorage(storageName, 'NCCAPPURL', session);
        } catch (e) {
            Object.keys(localStorage).forEach(item => {
                if (item.includes('appTempletStorage_')) {
                    delete localStorage[item];
                }
            });
            setGlobalStorage(storageName, 'NCCAPPURL', session);
        }
    } else {
        setGlobalStorage(storageName, 'NCCAPPURL', session);
    }
}

export function getAppReqParam(runContext) {
    let app = '', appcode = '', custom = '', ssc_templetid = '', pagecode = '', appN = '';
    
    let context = getMicroContext(runContext);
    if(context){
        return {
            app: context['n'],
            appcode: context['c'],
            pagecode: context['p'],
            custom: context['custom'] || '',
            ssc_templetid: context['ssc_templetid'] || '',
        };
    }
    
    appN = getParentWindow(window).location.hash.split('?');

    appN = appN && appN[1];
    if (CONFIG.isPageModal && getParentWindow(window) === getTopWindow()) {
        appN = getAppUrl().pageurl;
    }
    if (appN) {
        let appPrams = appN.split('&');
        if (appPrams && appPrams instanceof Array) {
            appPrams.forEach(item => {
                if (item.indexOf('=') != -1 && item.split('=') && item.split('=') instanceof Array) {
                    if (item.split('=')[0] === 'n') {
                        if (item.split('=')[1]) {
                            app = decodeURIComponent(decodeURIComponent(item.split('=')[1]));
                        }
                    }
                    if (item.split('=')[0] === 'c') {
                        if (item.split('=')[1]) {
                            appcode = decodeURIComponent(decodeURIComponent(item.split('=')[1]));
                        }
                    }
                    if (item.split('=')[0] === 'p') {
                        if (item.split('=')[1]) {
                            pagecode = decodeURIComponent(decodeURIComponent(item.split('=')[1]));
                        }
                    }
                    if (item.split('=')[0] === 'custom') {
                        if (item.split('=')[1]) {
                            custom = decodeURIComponent(decodeURIComponent(item.split('=')[1]));
                        }
                    }
                    if (item.split('=')[0] === 'ssc_templetid') {
                        if (item.split('=')[1]) {
                            ssc_templetid = decodeURIComponent(decodeURIComponent(item.split('=')[1]));
                        }
                    }
                }
            });
        }
    }

    return {
        app: app,
        appcode: appcode,
        pagecode: pagecode,
        custom: custom,
        ssc_templetid: ssc_templetid,
    };
    // if (!appcode) {
    // 	if (getParentWindow(window) && getParentWindow(window).parent) {
    // 		//嵌套两层iframe
    // 		appcode = getParamByLocation(getParentWindow(window).location.hash, 'c');
    // 	}
    // }
    // if (!custom) {
    // 	if (getParentWindow(window) && getParentWindow(window).parent) {
    // 		//嵌套两层iframe
    // 		custom = getParamByLocation(getParentWindow(window).location.hash, 'custom');
    // 	}
    // }

}

export function getOrigin() {
    let origin = getLocation(window).origin;
    if (!origin) {
        origin = getLocation(window).protocol + "//" + getLocation(window).hostname + (getLocation(window).port ? ':' + getLocation(window).port : '');
    }
    return origin;
}

export function getUrlKey() {
    let origin = getOrigin();
    let ifr = getMicroHref().replace(origin, '');
    let urlKeyMatchs = ifr.match(/urlKey=([^&$]+)/);
    if (urlKeyMatchs && urlKeyMatchs[1]) {
        return urlKeyMatchs[1];
    }
    return '';
}

